import React, { useState, useEffect } from "react";
import CurrencyInput from "../ClientForm/CurrencyInput";
import styles from "./RefinanceForm.module.css";

function Liabilities({ formData, setFormData, prevStep, nextStep }) {
  const [liabilities, setLiabilities] = useState({
    applicant1: formData.applicant1?.liabilities || [
      { type: "", limit: "", balance: "", repayment: "" },
    ],
    applicant2: formData.applicant2?.liabilities || [],
  });

  // ✅ Sync with formData and tag each with an owner
  useEffect(() => {
    setFormData({
      ...formData,
      applicant1: {
        ...(formData.applicant1 || {}),
        liabilities: liabilities.applicant1.map((l) => ({
          ...l,
          owner: "Applicant 1",
        })),
      },
      applicant2: formData.refinancingWithSomeone
        ? {
            ...(formData.applicant2 || {}),
            liabilities: liabilities.applicant2.map((l) => ({
              ...l,
              owner: "Applicant 2",
            })),
          }
        : {},
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [liabilities]);

  const updateLiability = (owner, index, field, value) => {
    const updated = [...liabilities[owner]];
    updated[index][field] = value;
    setLiabilities({ ...liabilities, [owner]: updated });
  };

  const addLiability = (owner) => {
    const updated = [
      ...liabilities[owner],
      { type: "", limit: "", balance: "", repayment: "" },
    ];
    setLiabilities({ ...liabilities, [owner]: updated });
  };

  const removeLiability = (owner, index) => {
    const updated = liabilities[owner].filter((_, i) => i !== index);
    setLiabilities({ ...liabilities, [owner]: updated });
  };

  const renderLiabilitySection = (owner, label) => (
    <div>
      <h4>{label}</h4>
      {liabilities[owner].map((liability, index) => (
        <div key={index} className={styles.formRow}>
          <select
            value={liability.type}
            onChange={(e) =>
              updateLiability(owner, index, "type", e.target.value)
            }
          >
            <option value="">Select Liability</option>
            <option value="Credit Card">Credit Card</option>
            <option value="Personal Loan">Personal Loan</option>
            <option value="Home Loan">Home Loan</option>
            <option value="HECS/HELP Debt">HECS/HELP Debt</option>
            <option value="Car Loan">Car Loan</option>
          </select>

          {liability.type === "Credit Card" ? (
            <CurrencyInput
              value={liability.limit}
              onChange={(val) =>
                updateLiability(owner, index, "limit", val)
              }
              placeholder="Card Limit ($)"
            />
          ) : liability.type ? (
            <>
              <CurrencyInput
                value={liability.balance}
                onChange={(val) =>
                  updateLiability(owner, index, "balance", val)
                }
                placeholder="Current Balance ($)"
              />
              <CurrencyInput
                value={liability.repayment}
                onChange={(val) =>
                  updateLiability(owner, index, "repayment", val)
                }
                placeholder="Monthly Repayment ($)"
              />
            </>
          ) : null}

          <button
            type="button"
            className={styles.removeBtn}
            onClick={() => removeLiability(owner, index)}
          >
            ✕
          </button>
        </div>
      ))}

      <button
        type="button"
        className={styles.addBtn}
        onClick={() => addLiability(owner)}
      >
        + Add Liability ({label})
      </button>
    </div>
  );

  return (
    <div className={styles.container}>
      <h3>Liabilities</h3>
      <p>Add any existing debts or obligations for each applicant:</p>

      {renderLiabilitySection("applicant1", "Applicant 1")}

      {formData.refinancingWithSomeone &&
        renderLiabilitySection("applicant2", "Applicant 2")}

      <div className={styles.navBtns}>
        <button type="button" onClick={prevStep}>
          ← Back
        </button>
        <button type="button" className={styles.nextBtn} onClick={nextStep}>
          Submit Application
        </button>
      </div>
    </div>
  );
}

export default Liabilities;
